function _s(o, i, p, l) { void 0 === i && (i = 400), void 0 === l && (l = !1), o.style.overflow = "hidden", l && (o.style.display = "block"); var n, t = window.getComputedStyle(o), s = parseFloat(t.getPropertyValue("height")), a = parseFloat(t.getPropertyValue("padding-top")), r = parseFloat(t.getPropertyValue("padding-bottom")), y = parseFloat(t.getPropertyValue("margin-top")), d = parseFloat(t.getPropertyValue("margin-bottom")), g = s / i, m = a / i, h = r / i, u = y / i, x = d / i; window.requestAnimationFrame(function t(e) { void 0 === n && (n = e); e -= n; l ? (o.style.height = g * e + "px", o.style.paddingTop = m * e + "px", o.style.paddingBottom = h * e + "px", o.style.marginTop = u * e + "px", o.style.marginBottom = x * e + "px") : (o.style.height = s - g * e + "px", o.style.paddingTop = a - m * e + "px", o.style.paddingBottom = r - h * e + "px", o.style.marginTop = y - u * e + "px", o.style.marginBottom = d - x * e + "px"), i <= e ? (o.style.height = "", o.style.paddingTop = "", o.style.paddingBottom = "", o.style.marginTop = "", o.style.marginBottom = "", o.style.overflow = "", l || (o.style.display = "none"), "function" == typeof p && p()) : window.requestAnimationFrame(t) }) } HTMLElement.prototype.slideToggle = function (t, e) { 0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e) }, HTMLElement.prototype.slideUp = function (t, e) { _s(this, t, e) }, HTMLElement.prototype.slideDown = function (t, e) { _s(this, t, e, !0) };

let PACK_SELECTION = {};

let packItems = []

function updateProductItemsScroll() {
    document.querySelectorAll('.product-form__products-wrapper .product-form__product-items').forEach((el) => {
        if (el.scrollHeight > el.clientHeight) {
            el.classList.add('has-scroll');
        } else {
            el.classList.remove('has-scroll');
        }
    });
}
window.addEventListener('load', updateProductItemsScroll);
window.addEventListener('resize', updateProductItemsScroll);

for (let item of bundleData.bundle_products) {
    item = {
        id: item.id,
        handle: item.handle,
        title: item.title,
        quantity: 0
    }
    packItems.push(item);
}

// Global click handler for frequency tabs (works on all templates)
document.addEventListener('click', (event) => {
    const tab = event.target.closest('.abos__frequency-tab[data-selling-plan-id]');
    if (!tab) return;
    const tabs = document.querySelectorAll('.abos__frequency-tab');
    tabs.forEach((t) => t.classList.remove('actif'));
    tab.classList.add('actif');
    if (typeof PACK_SELECTION !== 'undefined') {
        PACK_SELECTION.selling_plan_id = tab.dataset.sellingPlanId;
    }
});

// Global click handler for gift cards (free gift selector)
document.addEventListener('click', (event) => {
    const card = event.target.closest('.product-form__gift-card[data-gift-variant-id]');
    if (!card) return;
    const priceWrapper = document.querySelector('[data-gift-banner-price-wrapper]');
    const priceEl = document.querySelector('[data-gift-banner-price]');
    if (card.classList.contains('active')) {
        card.classList.remove('active');
        window.SELECTED_GIFT_VARIANT_ID = null;
        if (priceWrapper) priceWrapper.style.display = 'none';
    } else {
        document.querySelectorAll('.product-form__gift-card').forEach((c) => c.classList.remove('active'));
        card.classList.add('active');
        window.SELECTED_GIFT_VARIANT_ID = card.dataset.giftVariantId;
        if (priceWrapper && priceEl && card.dataset.productPrice) {
            priceEl.textContent = card.dataset.productPrice;
            priceWrapper.style.display = '';
        }
    }
});

class ProductTemplate extends HTMLElement {
    constructor() {
        super();

        this.querySelector('.product-form__submit').addEventListener('click', this.submitForm.bind(this));
        this.initEvents();

        this.querySelectorAll('[data-abo-recharge]').forEach((elem) => {
            elem.addEventListener('click', this.setRecurrence.bind(this))
        })

        this.all_packs_container = document.querySelectorAll("pack-item");
        this.last_number_selection = 0;
        this.first_load = true;
        this.content_updated = false;

    }

    setRecurrence(e) {
        let current = e.currentTarget;

        if (current.classList.contains('abos__one-shoot')) {
            this.querySelector('.abos__abo').classList.remove('active');
            current.classList.add('active');
        }
        else {

            this.querySelector('.abos__one-shoot').classList.remove('active');
            current.classList.add('active');

        }
    }

    setSellingPlan(e) {
        let selling_one_shoot = document.querySelector('.abos__one-shoot');

        document.querySelectorAll('#selling-plan-list option').forEach((option) => {
            option.selected = false;
        });

        const sellingPlanList = document.querySelector('#selling-plan-list');

        if (selling_one_shoot && selling_one_shoot.classList.contains('active')) {
            const zeroOption = document.querySelector('.rb-frequency-wrapper [data-selling-plan-id="0"]');
            if (zeroOption) {
                zeroOption.selected = true;
            }
            if (sellingPlanList) sellingPlanList.dispatchEvent(new Event("change"));
        }
        else {
            // Use new frequency tabs if available, fall back to old selectors
            let selling_plan_id;
            const activeFrequencyTab = document.querySelector('.abos__frequency-tab.actif[data-selling-plan-id]');
            if (activeFrequencyTab) {
                selling_plan_id = activeFrequencyTab.dataset.sellingPlanId;
            } else {
                let selling_plan = document.querySelector('.product-pack__recurring-current-value');
                if (selling_plan) {
                    selling_plan_id = selling_plan.dataset.sellingPlanId;
                    if (selling_plan_id == undefined) {
                        selling_plan_id = selling_plan.dataset.firstReccuring;
                    }
                }
            }
            if (selling_plan_id) {
                const planOption = document.querySelector(`.rb-frequency-wrapper [data-selling-plan-id="${selling_plan_id}"]`);
                if (planOption) planOption.selected = true;
            }
            if (sellingPlanList) sellingPlanList.dispatchEvent(new Event("change"));
        }
    }

    submitForm(event) {
        event.preventDefault();

        // We get the total quantity of smoothies in the pack
        let total = 0;
        for (const item of PACK_SELECTION.pack_items) {
            total += item.quantity;
        }

        if (total === PACK_SELECTION.coffee_times) {

            document.querySelector(".product-form__submit").classList.add("loading");

            this.setSellingPlan();

            // Update bundle size on recharge widget
            const bundle_size_select = document
                .querySelector(`#recharge-bundles #product-variant-list`)
            bundle_size_select.value = `${PACK_SELECTION.pack_name}`;
            bundle_size_select.dispatchEvent(new Event("change"));

            for (const item of PACK_SELECTION.pack_items) {
                // Set the variant size on recharge widget
                const id = item.title;
                const select_recharge = document
                    .querySelector(`.rb-item-actions [name="${id}"]`);
                console.log(id);
                select_recharge.value = item.quantity;
                select_recharge.dispatchEvent(new Event("change"));
            }

            setTimeout(this.submitBundle.bind(this), 400);

        } else {

            let reste = PACK_SELECTION.coffee_times - total;

            document.querySelector('.error__content').textContent = reste

            document.querySelector(".selection-packs-error").classList.add("open");

        }
    }

    submitBundle() {
        const submitBtn = document.querySelector(".rb-container form button");
        submitBtn.click();

        // Add free gift to cart as extra line item (optional selection)
        const TAG = '[GIFT][standard]';
        console.log(`${TAG} submitBundle() — SELECTED_GIFT_VARIANT_ID =`, window.SELECTED_GIFT_VARIANT_ID);
        if (window.SELECTED_GIFT_VARIANT_ID) {
            const id = Number(window.SELECTED_GIFT_VARIANT_ID);
            if (Number.isNaN(id)) {
                console.warn(`${TAG} variant id is not a valid number, skipped:`, window.SELECTED_GIFT_VARIANT_ID);
            } else {
                console.log(`${TAG} POST /cart/add.js payload:`, [{ id, quantity: 1 }]);
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: [{ id, quantity: 1 }] })
                }).then(async (res) => {
                    const body = await res.json().catch(() => null);
                    if (!res.ok) {
                        console.error(`${TAG} /cart/add.js failed`, res.status, body);
                    } else {
                        console.log(`${TAG} /cart/add.js OK`, body);
                    }
                }).catch((err) => console.error(`${TAG} /cart/add.js network error:`, err));
            }
        } else {
            console.log(`${TAG} no gift selected, request not sent`);
        }

        document.querySelector(".product-form__submit").classList.remove("loading");
    }

    initEvents() {
        this.querySelectorAll(".faq-item-title").forEach((button) => {
            button.addEventListener("click", this.toggleFaqItem.bind(this));
        });

        this.querySelectorAll('[data-open-modal-product]').forEach((elem) => {
            elem.addEventListener('click', this.openProductModal.bind(this))
        })

        document
            .querySelectorAll(".selection-packs-upgrade__decline")
            .forEach((button) => {
                button.addEventListener("click", () => {
                    document
                        .querySelectorAll(".selection-packs-upgrade")
                        .forEach((item) => {
                            item.classList.remove("open");
                        });
                });
            });
    }

    openProductModal(e) {
        const itemId = e.currentTarget.getAttribute('data-product-modal-id')

        let display = this.dataset.popUp

        fetch(`/products/${itemId}?view=${display}`)
            .then((data) => {
                console.log(data);
                return data.text()
            })
            .then((html) => {
                console.log(html);
                const modal = document.querySelector('.product-modal')
                modal.innerHTML = html;
                modal.classList.add('actif')
                document.addEventListener(
                    "click",
                    function (e) {
                        if (
                            !e.target.closest("[data-open-modal-product]") &&
                            !e.target.closest(".product-modal")
                        ) {
                            this.closeModal();
                        }
                    }.bind(this)
                );
                modal.querySelector('.close-modal').addEventListener('click', this.closeModal.bind(this))
                document.querySelector('html').classList.add('overflow-hidden')

                const sliderTouch = document.querySelectorAll(".scroll-touch");
                let isDown = false;
                let startX;
                let scrollLeft;

                for (let slider of sliderTouch) {
                    slider.addEventListener("mousedown", e => {
                        isDown = true;
                        slider.classList.add("active");
                        startX = e.pageX - slider.offsetLeft;
                        scrollLeft = slider.scrollLeft;
                    });
                    slider.addEventListener("mouseleave", () => {
                        isDown = false;
                        slider.classList.remove("active");
                        blockedLinks(isDown);
                    });
                    slider.addEventListener("mouseup", () => {
                        isDown = false;
                        slider.classList.remove("active");
                        blockedLinks(isDown);
                    });
                    slider.addEventListener("mousemove", e => {
                        if (!isDown) return;
                        e.preventDefault();
                        blockedLinks(isDown);
                        const x = e.pageX - slider.offsetLeft;
                        const walk = x - startX;
                        slider.scrollLeft = scrollLeft - walk;
                    });
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    closeModal() {
        const modal = document.querySelector('.product-modal')
        modal.classList.remove('actif')
        document.querySelector('html').classList.remove('overflow-hidden')
    }

    toggleFaqItem(e) {
        e.currentTarget
            .querySelector(".faq-close")
            .classList.toggle("faq-display-none");

        const item = e.currentTarget.parentNode.querySelector(".faq-item-text");
        console.log(item);

        item.slideToggle("250");
    }
}

customElements.define('product-template', ProductTemplate);

window.addEventListener('load', function () {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
});
window.addEventListener('resize', function () {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
});

class VariantItem extends HTMLElement {
    constructor() {
        super();

        this.updatePackContent()
        this.addEventListener('click', this.toggleVariant.bind(this));
    }

    toggleVariant() {
        document.querySelectorAll('variant-item').forEach((item) => {
            item.classList.remove('active');
        });
        this.changeUrl();
        this.classList.add('active');

        const submitBtn = document.querySelector('.product-form__submit');
        if (submitBtn) {
            if (this.classList.contains('disabled')) {
                submitBtn.classList.add('disabled');
            } else {
                submitBtn.classList.remove('disabled');
            }
        }

        this.updatePackContent();
    }


    changeUrl() {
        window.history.replaceState(
            {},
            "",
            `${this.dataset.url}`
        )
    }

    updatePackContent() {

        if (this.classList.contains("active")) {


            // We update the pack selection object
            PACK_SELECTION = {
                subtitle: this.dataset.productSubtitle,
                pack_id: parseInt(this.dataset.productId),
                pack_variant_id: parseInt(this.dataset.productVariantId),
                pack_name: this.dataset.productName,
                pack_price: parseFloat(this.dataset.productVariantPrice),
                pack_price_sub: parseFloat(this.dataset.productVariantPriceSub),
                variant_price: parseFloat(this.dataset.productCompareVariantPrice),
                reduction: parseInt(this.dataset.productReduction),
                coffee_times: parseInt(this.dataset.coffeeTimes),
                pack_image: this.dataset.productImage,
                pack_items: PACK_SELECTION.pack_items ? PACK_SELECTION.pack_items : packItems,
            };

            if (PACK_SELECTION.pack_items) {
                let total = 0;
                for (const item of PACK_SELECTION.pack_items) {
                    total += item.quantity;
                }

                document.querySelectorAll('[data-action="increment"]').forEach((elem) => {
                    elem.setAttribute("disabled", "false");
                });
                if (total > PACK_SELECTION.coffee_times) {
                    for (const item of PACK_SELECTION.pack_items) {
                        item.quantity = 0;
                    }
                    document.querySelectorAll('quantity-input .product-count').forEach((input) => {
                        input.value = 0;
                    })

                }

            }

            // this.updatePriceCta();
            this.updatePageContent();
            this.updatePrices();
        }
    }

    updatePageContent() {

        if (PACK_SELECTION) {
            const stepsNbItems = document.querySelector('.product-form--steps-nbItems');
            if (stepsNbItems) stepsNbItems.textContent = PACK_SELECTION.coffee_times === 1 ? 'votre ' : 'vos ' + PACK_SELECTION.coffee_times;

            const mediaEl = document.querySelector('caps-product-media');
            if (mediaEl && mediaEl.goToVariant) {
                mediaEl.goToVariant(PACK_SELECTION.pack_variant_id);
            }
        }

        const mediaTag = document.querySelector('.product-media__item .product-media__tag');
        if (PACK_SELECTION.reduction == 0) {
            document.querySelectorAll('.multiple-items').forEach((elem) => {
                elem.style.display = 'none'
            })
            if (mediaTag) mediaTag.classList.add('hidden');

        } else {
            document.querySelectorAll('.multiple-items').forEach((elem) => {
                elem.style.display = 'inline-block'
            })
            if (mediaTag) {
                mediaTag.textContent = '-' + PACK_SELECTION.reduction + '%';
                mediaTag.classList.remove('hidden');
            }

        }

        // Mirror active variant tag into caps-product-media reduction tag
        var reductionTag = document.querySelector('[data-reduction-tag]');
        if (reductionTag) {
            var activeVariantTag = document.querySelector('variant-item.active .product-form__variants--tag:not(.disabled)');
            if (activeVariantTag) {
                reductionTag.textContent = activeVariantTag.textContent.trim();
                reductionTag.style.display = '';
            } else {
                reductionTag.textContent = '';
                reductionTag.style.display = 'none';
            }
        }

    }

    updatePrices() {
        console.log(PACK_SELECTION);

        // set abo prices with price and price sub from the selected variant
        let abo_prices = document.querySelector('.abos__abo .abos__price');
        if (!abo_prices) return;
        let abo_original_price = abo_prices.querySelector('[data-abo-compare]') || abo_prices.querySelector('.price__sale .price-item.price-item--regular');
        let abo_price_sub = abo_prices.querySelector('[data-abo-price]') || abo_prices.querySelector('.price-item.price-item--sale.price-item--last');

        let sub_reduc = document.querySelector('product-template').dataset.reductionBundle;

        let sub_price = PACK_SELECTION.pack_price - (PACK_SELECTION.pack_price * sub_reduc / 100);

        // set abo prices with price and price sub from the selected variant
        if (abo_price_sub) abo_price_sub.textContent = sub_price.toFixed(2) + '€';
        if (abo_original_price) {
            abo_original_price.textContent = PACK_SELECTION.variant_price.toFixed(2) + '€';
            if (PACK_SELECTION.variant_price == 0) {
                abo_original_price.parentNode.style.display = 'none';
            }
            else {
                abo_original_price.parentNode.style.display = 'inline-block';
            }
        }

        let one_shoot_prices = document.querySelector('.abos__one-shoot .abos__price');
        if (!one_shoot_prices) return;

        let one_shoot_original_price = one_shoot_prices.querySelector('.price__sale .price-item.price-item--regular');
        let one_shoot_price_sub = one_shoot_prices.querySelector('[data-one-shoot-price]') || one_shoot_prices.querySelector('.price-item.price-item--sale.price-item--last');

        let one_shoot_price = PACK_SELECTION.pack_price;

        // set one shoot prices with price and price sub from the selected variant

        if (one_shoot_price_sub) one_shoot_price_sub.textContent = one_shoot_price.toFixed(2) + '€';
        if (one_shoot_original_price) {
            one_shoot_original_price.textContent = PACK_SELECTION.variant_price.toFixed(2) + '€';
            if (PACK_SELECTION.variant_price == 0) {
                one_shoot_original_price.parentNode.style.display = 'none';
            }
            else {
                one_shoot_original_price.parentNode.style.display = 'inline-block';
            }
        }

        // set price per capsule for the selected variant
        let price_per_abo = document.querySelector('.abo__capsules .variant--details__price-per');
        let price_per_one = document.querySelector('.one__capsules .variant--details__price-per');
        let price_per_current_variant_el = document.querySelector('variant-item.active .variant--details__price-per');
        let price_per_current_variant = price_per_current_variant_el ? price_per_current_variant_el.dataset.pricePer : null;

        if (price_per_one && price_per_current_variant) {
            price_per_one.textContent = Number(price_per_current_variant).toFixed(2) + '€';
        }

        if (price_per_abo && price_per_current_variant) {
            let multiplier = (sub_reduc - 1) / 100.00
            price_per_abo.textContent = (price_per_current_variant * multiplier * 10.00).toFixed(2) + '€';
        }

    }
}

customElements.define('variant-item', VariantItem);

class QuantityInput extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[name="quantity"]');
        this.addEventListener("click", this.changeQuantity.bind(this));
        this.addEventListener("updateContent", this.changeQuantity.bind(this));

        this.updateSmoothiesCounter();
    }

    changeQuantity(event) {
        const target = event.target;
        let total = 0;

        // Get the total quantity of smoothies in the pack
        for (const item of PACK_SELECTION.pack_items) {
            total += item.quantity;
        }

        console.log(total, PACK_SELECTION.coffee_times);

        const value = parseInt(this.input.value);

        if (target.classList.contains("quantity-input__btn")) {
            if (target.dataset.action === "increment") {
                if (total < PACK_SELECTION.coffee_times) {
                    target
                        .closest("quantity-input")
                        .querySelector('[data-action="decrement"]')
                        .removeAttribute("disabled");
                    // We update the input value with the new quantity
                    this.input.value = parseInt(value) + 1;
                    if (this.input.value == this.input.max) {
                        this.parentNode.classList.add('out-of-stock-dinamique');
                    }
                } else {
                    document.querySelectorAll('[data-action="increment"]').forEach((elem) => {
                        elem.setAttribute("disabled", "true");
                    });
                }
            } else if (target.dataset.action === "decrement") {
                this.parentNode.classList.remove('out-of-stock-dinamique');
                document.querySelectorAll('[data-action="increment"]').forEach((elem) => {
                    elem.setAttribute("disabled", "false");
                });
                if (value > 0) {
                    this.input.value = parseInt(value) - 1;
                    // We update the input value with the new quantity
                    if (this.input.value == 0) {
                        target.setAttribute("disabled", "disabled");
                    }

                } else {
                }
            }
        }

        let total_smoothies = 0;

        let quantity_inputs = document.querySelectorAll(
            '.product-form__product-item quantity-input [name="quantity"][data-handle]'
        );

        for (const input of quantity_inputs) {
            total_smoothies += parseInt(input.value);
        }

        this.updateSelectionContent();
        this.updateSmoothiesCounter();
    }



    updateSmoothiesCounter() { }

    updateSelectionContent() {

        console.log('change quantity');
        const quantity_inputs = document.querySelectorAll(
            ".product-form__product-item quantity-input"
        );
        for (const input of quantity_inputs) {
            for (let item of PACK_SELECTION.pack_items) {
                // Update the quantity of each smoothie in the pack selection object
                if (item.handle === input.querySelector("input").dataset.handle) {
                    item.quantity = parseInt(input.querySelector("input").value);
                    console.log(item);
                }
            }
        }
    }
}

if (customElements.get("quantity-input") === undefined) {
    customElements.define("quantity-input", QuantityInput);
}


const disabledLinks = (urls, attr, setAttr) => {
    [...urls].forEach(url => {
        url.setAttribute(attr, setAttr)
    })
}

const blockedLinks = (down) => {
    const allLinks = document.querySelectorAll('.url-card');
    down
        ? disabledLinks(allLinks, 'disabled', 'disabled')
        : disabledLinks(allLinks, 'disabled', '')
}




class ReccuringOption extends HTMLElement {
    constructor() {
        super();

        this.addEventListener("click", this.selectOption.bind(this));

        if (this.dataset.subscribe === "true") {
            this.initEventSelectReccuring();
        }

        // check if click outside .product-pack__recurring-select-values and close it
        document.addEventListener("click", (event) => {
            if (event.target.closest(".product-pack__recurring-select") === null) {
                this.querySelector(".product-pack__recurring-select-values")
                    ? this.querySelector(
                        ".product-pack__recurring-select-values"
                    ).classList.add("hidden")
                    : null;
                this.querySelector(".product-pack__recurring-select")
                    ? this.querySelector(
                        ".product-pack__recurring-select"
                    ).classList.remove("actif")
                    : null;
            }
        });
    }

    initEventSelectReccuring() {
        // New frequency tabs (from product-form-abo snippet)
        this.querySelectorAll('.abos__frequency-tab[data-selling-plan-id]').forEach((tab) => {
            tab.addEventListener('click', (event) => {
                this.querySelectorAll('.abos__frequency-tab').forEach((t) => t.classList.remove('actif'));
                tab.classList.add('actif');
                PACK_SELECTION.selling_plan_id = tab.dataset.sellingPlanId;
            });
        });

        // Legacy recurring select (old HTML structure) - guarded with null checks
        this.querySelectorAll(
            ".product-pack__recurring-current, .product-pack__recurring-select svg "
        ).forEach((select) => {
            select.addEventListener("click", (event) => {
                event.preventDefault();
                this.querySelector(
                    ".product-pack__recurring-select-values"
                )?.classList.toggle("hidden");
                this.querySelector(".product-pack__recurring-select")?.classList.toggle(
                    "actif"
                );
            });
        });

        this.querySelectorAll(
            ".product-pack__recurring-select-values label"
        ).forEach((select) => {
            select.addEventListener("click", (event) => {
                event.preventDefault();
                const recurringCurrent = this.querySelector(
                    ".product-pack__recurring-current"
                );
                if (recurringCurrent) {
                    recurringCurrent.innerHTML = `<span class="product-pack__recurring-current-value" data-selling-plan-id="${event.currentTarget
                        .getAttribute("for")
                        .replace("selling_plan_", "")}">${event.target.innerHTML}</span>`;
                }
                this.querySelector(
                    ".product-pack__recurring-select-values"
                )?.classList.toggle("hidden");
                this.querySelector(".product-pack__recurring-select")?.classList.remove(
                    "actif"
                );

                PACK_SELECTION.selling_plan_id = event.currentTarget
                    .getAttribute("for")
                    .replace("selling_plan_", "");

                document
                    .querySelectorAll(".product-pack__recurring-select-values label")
                    .forEach((label) => {
                        label.classList.remove("actif");
                        if (
                            label.getAttribute("for") ===
                            event.currentTarget.getAttribute("for")
                        ) {
                            label.classList.add("actif");
                        }
                    });
            });
        });
    }

    selectOption(event) {
        if (this.dataset.subscribe === "true") {
            document.querySelector(
                'pack-item:not([data-discover-pack="true"]) [data-unit-price-sub]'
            )
                ? document
                    .querySelectorAll(
                        'pack-item:not([data-discover-pack="true"]) [data-unit-price-sub]'
                    )
                    .forEach((price) => {
                        price.classList.remove("hidden");
                    })
                : null;
            document.querySelector(
                'pack-item:not([data-discover-pack="true"]) [data-unit-price-oneshot]'
            )
                ? document
                    .querySelectorAll(
                        'pack-item:not([data-discover-pack="true"]) [data-unit-price-oneshot]'
                    )
                    .forEach((price) => {
                        price.classList.add("hidden");
                    })
                : null;
        } else {
            document.querySelector(
                'pack-item:not([data-discover-pack="true"]) [data-unit-price-sub]'
            )
                ? document
                    .querySelectorAll(
                        'pack-item:not([data-discover-pack="true"]) [data-unit-price-sub]'
                    )
                    .forEach((price) => {
                        price.classList.add("hidden");
                    })
                : null;
            document.querySelector(
                'pack-item:not([data-discover-pack="true"]) [data-unit-price-oneshot]'
            )
                ? document
                    .querySelectorAll(
                        'pack-item:not([data-discover-pack="true"]) [data-unit-price-oneshot]'
                    )
                    .forEach((price) => {
                        price.classList.remove("hidden");
                    })
                : null;
        }
        document.querySelectorAll("recurring-option").forEach((option) => {
            option.classList.remove("actif");
        });
        this.classList.add("actif");

        const rbSelectEl = document.querySelector(".rb-select [data-selling-plan-id]");
        const select = rbSelectEl ? rbSelectEl.closest("select") : null;

        if (this.dataset.subscribe === "true") {
            if (PACK_SELECTION.selling_plan_id === undefined) {
                // Try new frequency tabs first, then fall back to old selector
                const activeTab = document.querySelector('.abos__frequency-tab.actif[data-selling-plan-id]');
                const oldInput = document.querySelector(".product-pack__recurring-select-values input:checked");
                if (activeTab) {
                    PACK_SELECTION.selling_plan_id = activeTab.dataset.sellingPlanId;
                } else if (oldInput) {
                    PACK_SELECTION.selling_plan_id = oldInput.value;
                }
            }
            if (select) {
                const planEl = document.querySelector(
                    `.rb-select [data-selling-plan-id="${PACK_SELECTION.selling_plan_id}"]`
                );
                if (planEl) select.selectedIndex = planEl.index;
            }
        } else {
            if (select) select.selectedIndex = 0;
        }

        if (select) select.dispatchEvent(new Event("change"));

        if (document.querySelector(".product-sub__top-bar")) {
            const activeLabel = document.querySelector(
                ".product-pack__recurring-select-values .actif"
            );
            if (activeLabel) {
                document.querySelector(".top-bar__recuring").innerHTML = activeLabel.innerHTML;
            }
        }


    }
}

if (customElements.get("recurring-option") === undefined) {
    customElements.define("recurring-option", ReccuringOption);
}
